// Google Analytics 4 — gtag.js bootstrap.
// The measurement ID arrives via the linked Google Analytics connector as a
// public (VITE_) env var, so it is safe to inline into the browser bundle.

const GA_ID = import.meta.env[
  "VITE_LOVABLE_CONNECTOR_GOOGLE_ANALYTICS_API_KEY"
] as string | undefined;

declare global {
  interface Window {
    dataLayer?: unknown[];
    __wevangGaInitialized?: boolean;
  }
}

type GtagFn = (...args: unknown[]) => void;

function getGtag(): GtagFn | undefined {
  if (typeof window === "undefined") return undefined;
  const w = window as unknown as { gtag?: GtagFn; dataLayer?: unknown[] };
  if (!w.dataLayer) w.dataLayer = [];
  if (!w.gtag) {
    // gtag.js only processes the Arguments object — pushing a plain array
    // is silently ignored and no hits are sent.
    w.gtag = function gtag() {
      // eslint-disable-next-line prefer-rest-params
      w.dataLayer!.push(arguments);
    } as GtagFn;
  }
  return w.gtag;
}

export function initAnalytics(): void {
  if (!GA_ID || typeof window === "undefined") return;
  if (window.__wevangGaInitialized) return;
  window.__wevangGaInitialized = true;

  const script = document.createElement("script");
  script.async = true;
  script.src = `https://www.googletagmanager.com/gtag/js?id=${GA_ID}`;
  document.head.appendChild(script);

  const gtag = getGtag();
  if (!gtag) return;
  gtag("js", new Date());
  gtag("config", GA_ID);
}

export function trackPageView(path: string): void {
  const gtag = getGtag();
  if (!gtag || !GA_ID) return;
  gtag("event", "page_view", {
    page_path: path,
    page_title: typeof document !== "undefined" ? document.title : undefined,
  });
}
